import React from 'react';
import PropTypes from 'prop-types';
import TTLProxy from "../../common/TTLAsyncProxy";
import MDSpinner from 'react-md-spinner';
import {TractorOperatorEndpoint, TractorsEndpoints} from "../../common/ProxyEndpoints";
import {UncontrolledTooltip} from "reactstrap";
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import PermissionRender from "../../components/PermissionRender/PermissionRender";
import {UserRoles} from "../../common/Constants";
import _ from 'lodash';
import EventListener from "../../common/EventListener";
import EventActions from "../../common/Events/Actions";
import {css} from "glamor";
import {formatQuantityShort} from "../../common/QuantityHelper";

const tooltipClass = css({
    maxWidth: 300,
    width: 300,
    backgroundColor: 'rgb(0,0,0)'
});

class WorkloadComponent extends React.Component {

    static propTypes = {
        tractor: PropTypes.object,
        operator: PropTypes.object
    };

    constructor(props){
        super(props);

        this.state = {
            isBusy: false,
            data: null,
            hasError: false
        };

        this.proxy = TTLProxy.getInstance();
        this.loadState = this.loadState.bind(this);
    }

    async loadState(){

        const proxy = this.proxy;
        const { tractor , operator } = this.props;

        if(this.state.isBusy){
            return;
        }

        this.setState({
            isBusy: true,
            hasError: false
        });

        try{

            let endpoint = tractor ? TractorsEndpoints.getOperationSummary(tractor.id) : TractorOperatorEndpoint.getOperationSummary(operator.id);
            const response = await proxy.processRequest(endpoint);

            this.setState({
                data: response.getPayload()
            });

        }
        catch (e) {

            this.setState({
                hasError: true
            });

        }
        finally {
            this.setState({ isBusy: false });
        }

    }

    refresh(){
        return this.loadState();
    }

    componentDidMount() {
        return this.loadState();
    }

    render() {

        const { isBusy , data , hasError } = this.state;
        const id = (this.props.tractor || this.props.operator).id;

        return <React.Fragment>

            <EventListener events={EventActions.RefreshActivePage} onEvent={() => this.loadState()}/>

            {(isBusy || _.isNil(data)) ? <MDSpinner singleColor={"#00c157"} size={16} /> : (hasError ? <i className="fa fa-exclamation-triangle" onClick={() => this.loadState()} title="Failed loading statistics" style={{ color: "#ffe363"}}/> : <React.Fragment>

            <span id={`tractor_${id}_workload`}>
                {data.totalRequests > 0 ? <span>{formatQuantityShort(data,{ acre: 'totalAcresAssigned' , hectare: 'totalHectaresAssigned' })} <span className="font-weight-bold">active</span> / {formatQuantityShort(data,{ acre: 'totalAcresCompleted' , hectare: 'totalHectaresCompleted' })} <span className="font-weight-bold">complete</span></span> : "Idle"}
            </span>

            <UncontrolledTooltip target={`tractor_${id}_workload`}
                                 placement="bottom"
                                 offset={10}
                                 innerClassName={`${tooltipClass} p-2`}
                                 fade={false}>

                <div className="text-left">

                    {this.props.tractor && <React.Fragment>
                        <PermissionRender roles={[UserRoles.Admin,UserRoles.CallCenterAgent]}>

                            <div>
                                <span><b>Payout:</b> <CurrencyLabel value={data.totalIncomePayout}/></span>
                            </div>

                            <div>
                                <span><b>Payout (Pending):</b> <CurrencyLabel value={data.totalPendingIncomePayout}/></span>
                            </div>

                            <div>
                                <span><b>Revenue (Overall):</b> <CurrencyLabel value={data.totalIncome}/></span>
                            </div>

                        </PermissionRender>

                        <PermissionRender roles={[UserRoles.Owner]}>

                            <div>
                                <span><b>Revenue:</b> <CurrencyLabel value={data.totalIncomePayout}/></span>
                            </div>


                            <div>
                                <span><b>Commission:</b> <CurrencyLabel value={data.totalIncomeCommission}/></span>
                            </div>

                            <div>
                                <span><b>Revenue (Pending):</b> <CurrencyLabel value={data.totalPendingIncomePayout}/></span>
                            </div>


                        </PermissionRender>
                    </React.Fragment>}

                    {this.props.operator && <React.Fragment>
                        <PermissionRender roles={[UserRoles.Admin,UserRoles.CallCenterAgent]}>

                            <div>
                                <span><b>Payout:</b> <CurrencyLabel value={data.totalIncomePayout}/></span>
                            </div>

                            <div>
                                <span><b>Payout (Pending):</b> <CurrencyLabel value={data.totalPendingIncomePayout}/></span>
                            </div>

                            <div>
                                <span><b>Revenue (Overall):</b> <CurrencyLabel value={data.totalIncome}/></span>
                            </div>
                        </PermissionRender>

                        <PermissionRender roles={[UserRoles.Owner]}>

                            <div>
                                <span><b>Revenue:</b> <CurrencyLabel value={data.totalIncomePayout}/></span>
                            </div>

                            <div>
                                <span><b>Revenue (Pending):</b> <CurrencyLabel value={data.totalPendingIncomePayout}/></span>
                            </div>

                        </PermissionRender>
                    </React.Fragment>}


                    <div>
                        <span><b>Completed:</b> <NumberLabel value={data.totalCompletedRequests}/> / {formatQuantityShort(data,{ acre: 'totalAcresCompleted' , hectare: 'totalHectaresCompleted' })} - <NumberLabel value={data.totalWorkingDuration} maximumFractionDigits={1}/> hr(s)</span>
                    </div>

                    <div>
                        <span><b>Assigned:</b> <NumberLabel value={data.totalAssignedRequests}/> / {formatQuantityShort(data,{ acre: 'totalAcresAssigned' , hectare: 'totalHectaresAssigned' })}</span>
                    </div>

                    <div>
                        <span><b>Cancelled:</b> <NumberLabel value={data.totalCancelledRequests}/></span>
                    </div>

                </div>

            </UncontrolledTooltip>

        </React.Fragment>)}

        </React.Fragment>

    }
}

export default WorkloadComponent;



// WEBPACK FOOTER //
// ./src/views/Tractors/WorkloadComponent.js